export default "__VITE_ASSET__BCV5yCPA__"